// Product Acoordian Js
document.addEventListener("DOMContentLoaded", () => {
  const headers = document.querySelectorAll(".product-accordion-header");

  headers.forEach(header => {
    header.addEventListener("click", () => {
      const isActive = header.classList.contains("active");

      // close all
      headers.forEach(h => {
        h.classList.remove("active");
        h.nextElementSibling.style.maxHeight = null;
      });

      // open clicked
      if (!isActive) {
        header.classList.add("active");
        const content = header.nextElementSibling;
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });
  document.querySelector('.main-duk-section .product-accordion-header').click();
});

